import moment from "moment";
import iconEdit from "../../../../../assests/editForm.png";
import CalendarEventPopup from "../calendarEventPopup/CalendarEventPopup";
import MyTooltipComponent from "../../../ui/myTooltipComponent/MyTooltipComponent";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from "./Templates.module.css";
import "../FullCalender.css";

const MonthEventTemplate = (props) => {

    return (
        <MyTooltipComponent offsetX={100} offsetY={-15} Content={() => <CalendarEventPopup {...props} calendarType="FullCalendar" />} className={classes.DropHover}>
            <div className={classes.MonthEventWrapper}>
                <div className={`${classes.Event} ${classes.MonthEvent} ${props.holiday ? classes.Holiday : null}`}
                    style={{
                        borderColor: props.holiday ? "#53C8E1" : props.domainColor,
                        backgroundColor: props.holiday ? "#53C8E133" : props.IsAllDay ? `${props.DomainColor}33` : !props.IsAllDay && "unset"
                    }} >
                    {!props.IsAllDay && <div className={classes.Time}>
                        {`${moment(props.StartTime).format('HH:mm')}`}
                        {/* {`${  instance.formatDate(props.StartTime,{ format: 'EEEE' })}`} */}
                    </div>}
                    <div className={classes.Subject}>{props.Subject}</div>

                    {props.isAssessment && <AccessibilityHiddenImg className={classes.IconEdit} src={iconEdit} />}
                </div>
            </div>
        </MyTooltipComponent>
    )
}

export default MonthEventTemplate;